import { IBaseAction } from '../../constants';

export interface TimeChangeRequestState {
    data: {
        rpl: any;
        id: string;
    };
    error?: any
}

export interface TimeChangeRequestInitialState {
    rpl: any;
    id: string;
}

export const TIME_CHANGE_REQUEST = 'TIME_CHANGE_REQUEST';
export const TIME_CHANGE_REQUEST_SUCCESS = 'TIME_CHANGE_REQUEST_SUCCESS';
export const TIME_CHANGE_REQUEST_CLEAR = 'TIME_CHANGE_REQUEST_CLEAR';
export const TIME_CHANGE_REQUEST_FAILURE = 'TIME_CHANGE_REQUEST_FAILURE';
interface TimeChangeRequestAction extends IBaseAction {
    type: typeof TIME_CHANGE_REQUEST | typeof TIME_CHANGE_REQUEST_SUCCESS | typeof TIME_CHANGE_REQUEST_CLEAR | typeof TIME_CHANGE_REQUEST_FAILURE;
    payload: {
        data: TimeChangeRequestInitialState;
        error?: any;
    };
}

export const TIME_CHANGE_FLIGHTS_REQUEST = 'TIME_CHANGE_FLIGHTS_REQUEST';
export const TIME_CHANGE_FLIGHTS_REQUEST_SUCCESS = 'TIME_CHANGE_FLIGHTS_REQUEST_SUCCESS';
export const TIME_CHANGE_FLIGHTS_REQUEST_FAILURE = 'TIME_CHANGE_FLIGHTS_REQUEST_FAILURE';
export const TIME_CHANGE_FLIGHTS_REQUEST_CLEAR = 'TIME_CHANGE_FLIGHTS_REQUEST_CLEAR';
export interface TimeChangeFlightSRequestAction extends IBaseAction {
    type:
    | typeof TIME_CHANGE_FLIGHTS_REQUEST
    | typeof TIME_CHANGE_FLIGHTS_REQUEST_SUCCESS
    | typeof TIME_CHANGE_FLIGHTS_REQUEST_FAILURE
    | typeof TIME_CHANGE_FLIGHTS_REQUEST_CLEAR;
    payload?: {
        data: any;
    };
}

export const TIME_CHANGE_FLIGHTS_AFTER_REJECTION = 'TIME_CHANGE_FLIGHTS_AFTER_REJECTION';
export const TIME_CHANGE_FLIGHTS_AFTER_REJECTION_SUCCESS = 'TIME_CHANGE_FLIGHTS_AFTER_REJECTION_SUCCESS';
export const TIME_CHANGE_FLIGHTS_AFTER_REJECTION_FAILURE = 'TIME_CHANGE_FLIGHTS_AFTER_REJECTION_FAILURE';
export const TIME_CHANGE_FLIGHTS_AFTER_REJECTION_CLEAR = 'TIME_CHANGE_FLIGHTS_AFTER_REJECTION_CLEAR';
export interface TimeChangeFlightsAfterRejectionRequestAction extends IBaseAction {
    type:
    | typeof TIME_CHANGE_FLIGHTS_AFTER_REJECTION
    | typeof TIME_CHANGE_FLIGHTS_AFTER_REJECTION_SUCCESS
    | typeof TIME_CHANGE_FLIGHTS_AFTER_REJECTION_FAILURE
    | typeof TIME_CHANGE_FLIGHTS_AFTER_REJECTION_CLEAR;
    payload?: {
        data: any;
    };
}

export type TimeChangeActionTypes = TimeChangeRequestAction | TimeChangeFlightSRequestAction | TimeChangeFlightsAfterRejectionRequestAction;